import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "gamma",
    aws_cognito_region: "ap-southeast-2",
    aws_cognito_identity_pool_id: "ap-southeast-2:d7e5f005-84bd-4b7e-95bf-a22fff556cca",
    aws_user_pools_id: "ap-southeast-2_f18YEdWYr",
    aws_user_pools_web_client_id: "7fh9p2qf75g676u3l9a5erh8gr",
    Auth: {
      identityPoolId: "ap-southeast-2:d7e5f005-84bd-4b7e-95bf-a22fff556cca",
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_f18YEdWYr",
      userPoolWebClientId: "7fh9p2qf75g676u3l9a5erh8gr",
    },
    oauth: {
      domain: "whs-safer-gamma-sg.auth.ap-southeast-2.amazoncognito.com",
      redirectSignIn: "https://gamma.sg.safer.whs.amazon.dev",
      redirectSignOut: "https://gamma.sg.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve gamma to "test".
  const stage = "gamma".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
